<template>
    <div class="attributes-page">
        <page-header :page-title="t('ATTRIBUTES.INDEX')"></page-header>
        <div class="task-section">
            <div class="row no-gutters">
                <div class="col-xl-2 col-lg-2 col-md-3 col-sm-3 col-4">
                    <div class="labels-container">
                        <div class="slimScrollDiv"
                             style="position: relative; overflow: hidden; width: auto; height: 100%;">
                            <div class="lablesContainerScroll" style="overflow: hidden; width: auto; height: 100%;">
                                <div class="filters-block">
                                    <h5>Cadastro de:</h5>
                                    <div class="filters">
                                        <span v-for="(iten, key) in tables" :key="key">
                                            <a href="#"
                                               @click="index(iten.id)"
                                               :class="{'active': iten.active}">
                                            <i class="icon-users"/> {{ iten.text }}
                                        </a>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xl-10 col-lg-10 col-md-9 col-sm-9 col-8 mt-1">
                    <div class="tasks-container ">
                        <div class="attributes-tabs">
                            <div class="attributes-tab" :class="setBackgroud(1)" @click="indexUpperCase(1)">
                                <a class="attributes-tab__link" :class="setActive(1)"><h6>Campos
                                    Obrigatórios</h6></a>
                            </div>
                            <div class="attributes-tab" :class="setBackgroud(2)" @click="indexUpperCase(2)">
                                <a class="attributes-tab__link" :class="setActive(2)"><h6>Campos em Caixa
                                    Alta</h6></a>
                            </div>
                        </div>
                        <div class="slimScrollDiv"
                             style="position: relative; overflow: hidden; width: auto; height: 100%;">
                            <div class="tasksContainerScroll" style="overflow: auto; width: auto; height: 100%;">
                                <div class="row no-gutters justify-content-center">
                                    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
                                         v-if="headerActive === 1">
                                        <section class="task-list">
                                            <div class="row gutters pl-3 pt-3 w-100">
                                                <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12 w-100 mb-2" v-for="(iten, key) in items" :key="key">
                                                    <div class="attribute-card">
                                                        <label :class="isRequiredClass(iten.is_required)"
                                                               class="attribute-card__name"
                                                        >{{
                                                                iten.traduction_name
                                                            }}:</label>
                                                        <div class="attribute-card__switch">
                                                            <div class="custom-control custom-switch">
                                                                <input type="checkbox" v-model="iten.is_required"
                                                                       @change="changeAtr(iten.id)"
                                                                       class="custom-control-input" :id="`atr${iten.id}`">
                                                                <label data-cy="profile_update_about_r2"
                                                                       class="custom-control-label"
                                                                       :for="`atr${iten.id}`">Obrigatório</label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </section>
                                    </div>
                                    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
                                         v-if="headerActive === 2">
                                        <section class="task-list">
                                            <div class="row gutters pl-3 pt-3 w-100">
                                                <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12 w-100 mb-2" v-for="(iten, key) in itemsUpper" :key="key">
                                                    <div class="attribute-card">
                                                        <label class="attribute-card__name">{{
                                                                castNameItemUpper(iten)
                                                            }}:</label>
                                                        <div class="attribute-card__switch">
                                                            <div class="custom-control custom-switch">
                                                                <input type="checkbox" v-model="iten.is_upper_case"
                                                                       @change="changeAtrUpper(iten.id)"
                                                                       class="custom-control-input" :id="`atr${iten.id}`">
                                                                <label data-cy="profile_update_about_r2"
                                                                       class="custom-control-label"
                                                                       :for="`atr${iten.id}`">Caixa Alta</label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </section>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import PageHeader from '../../components/layouts/pageHeader';
import {useToast} from 'vue-toastification';
import {useI18n} from 'vue-i18n';
import AttibutesValidations from '../../services/AttibutesValidations';
import AttributesUpperCase from '../../services/AttributesUpperCase';

export default {
    name: "indexAtributesComponent",
    components: {PageHeader},
    setup() {
        const toast = useToast();
        const {t} = useI18n();
        return {t, toast}
    },
    data() {
        return {
            items: [],
            itemsUpper: [],
            tables: [],
            headerActive: 1,
        }
    },
    mounted() {
        this.$canAccess('TableValidations_list');
        this.listTablesValidations();
    },
    methods: {
        castNameItemUpper(item){
            if (item.is_upper_case){
                return item.traduction_name.toUpperCase();
            }
            return item.traduction_name;
        },
        setBackgroud(context) {
            if (context === this.headerActive) {
                return 'background-active-header';
            }
        },
        setActive(context) {
            if (context === this.headerActive) {
                return 'active';
            }
        },
        listTablesValidations() {
            this.$store.commit('changeLoading', true);
            AttibutesValidations.listAllTables().then(resp => {
                this.tables = resp.data;
                this.index(this.tables[0].id);
            }).catch(() => {
                this.tables = [];
                this.$store.commit('changeLoading', false);
            })
        },
        index(id) {
            this.headerActive = 1;
            this.$store.commit('changeLoading', true);
            AttibutesValidations.getByTableId(id).then(resp => {
                this.items = resp.data;
                this.tables.forEach(i => {
                    if (i.id == id) {
                        i.active = true;
                    } else i.active = false;
                })
                this.$store.commit('changeLoading', false);
            }).catch(() => {
                this.items = [];
                this.$store.commit('changeLoading', false);
            })
        },
        indexUpperCase(context) {
            this.headerActive = context;
            let id = this.tables.find(i => i.active).id;
            this.$store.commit('changeLoading', true);
            AttributesUpperCase.getByTableId(id).then(resp => {
                this.itemsUpper = resp.data;
                this.$store.commit('changeLoading', false);
            }).catch(() => {
                this.itemsUpper = [];
                this.$store.commit('changeLoading', false);
            })
        },
        isRequiredClass(bool) {
            if (bool) return 'required';
            return '';
        },
        changeAtr(id) {
            this.$store.commit('changeLoading', true);
            AttibutesValidations.updateRequired(id).then((resp) => {
                let id = resp?.data?.id;
                this.items.forEach(i => {
                    if (i.id === id) {
                        i.is_required = resp.data.is_required;
                    }
                })
                this.toast.success(this.t('GENERAL.UPDATED_SUCCESSFULL'));
                this.$store.commit('changeLoading', false);
            }).catch(() => {
                this.items.forEach(i => {
                    if (i.id === id) {
                        i.is_required = !i.is_required;
                    }
                })
                this.$store.commit('changeLoading', false);
            })
        },
        changeAtrUpper(id) {
            this.$store.commit('changeLoading', true);
            AttributesUpperCase.updateUpperCase(id).then((resp) => {
                let id = resp?.data?.id;
                this.itemsUpper.forEach(i => {
                    if (i.id === id) {
                        i.is_required = resp.data.is_required;
                    }
                })
                this.toast.success(this.t('GENERAL.UPDATED_SUCCESSFULL'));
                this.$store.commit('changeLoading', false);
            }).catch(() => {
                this.items.forEach(i => {
                    if (i.id === id) {
                        i.is_required = !i.is_required;
                    }
                })
                this.$store.commit('changeLoading', false);
            })
        }
    }
}
</script>

<style scoped>
.attributes-page .filters-block {
    margin: 1rem 0 2rem 0;
}

.attributes-page .filters-block h5 {
    color: #3a4f49;
    font-size: .78rem;
    font-weight: 700;
    letter-spacing: .05em;
    margin: 0 0 .8rem 0;
    padding: 0 1rem;
    text-transform: uppercase;
}

.attributes-page .filters-block .filters {
    display: flex;
    flex-direction: column;
    gap: 2px;
}

.attributes-page .filters-block .filters a {
    border-radius: 8px;
    color: #5c6b66;
    font-size: .78rem;
    margin: 0 4px;
    padding: .5rem .8rem;
}

.attributes-page .filters-block .filters a i {
    color: #0e5e4e;
    font-size: 1rem;
    margin: 0 .55rem 0 0;
}

.attributes-page .filters-block .filters a:hover {
    background: #eef4f2;
    color: #173b34;
}

.attributes-page .filters-block .filters a.active {
    background: #e7f4f0;
    color: #0e5e4e;
    font-weight: 700;
}

.attributes-tabs {
    display: flex;
    gap: 8px;
    margin: 0 0 16px;
    padding: 0 12px;
}

.attributes-tab {
    background: #ffffff;
    border: 1px solid #e6ebf1;
    border-radius: 10px;
    cursor: pointer;
    flex: 1;
    padding: 10px 16px;
    text-align: center;
    transition: background-color .15s ease, border-color .15s ease, box-shadow .15s ease;
}

.attributes-tab:hover {
    border-color: #bfd8d1;
}

.attributes-tab.background-active-header {
    background: #e7f4f0;
    border-color: #0e5e4e;
    box-shadow: 0 6px 16px rgba(14, 94, 78, 0.12);
}

.attributes-tab__link {
    color: #6b7c78;
    display: block;
    text-decoration: none;
}

.attributes-tab__link h6 {
    font-size: .85rem;
    font-weight: 600;
    margin: 0;
}

.attributes-tab__link.active {
    color: #0e5e4e;
}

.attributes-tab__link.active h6 {
    font-weight: 700;
}

.task-list {
    height: auto;
    padding: 0 8px 16px;
}

.attribute-card {
    background: #f6f8f8;
    border: 1px solid #e8ecec;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    height: 100%;
    padding: 12px 14px;
    transition: border-color .15s ease, box-shadow .15s ease;
}

.attribute-card:hover {
    border-color: #bfd8d1;
    box-shadow: 0 6px 16px rgba(15, 23, 42, 0.06);
}

.attribute-card__name {
    color: #3a4f49;
    font-size: .85rem;
    font-weight: 600;
    line-height: 1.3;
    margin: 0 0 10px;
}

.attribute-card__switch {
    align-items: center;
    border-top: 1px solid #eef2f0;
    display: flex;
    margin-top: auto;
    padding-top: 10px;
}

.background-active-header {
    background: #eff1f5;
    border-bottom-color: #0e5e4e !important;
    border-bottom-width: 2px !important;
}

::-webkit-scrollbar {
    width: 5px;
    height: 5px;
}

::-webkit-scrollbar-track {
    background: #f1f1f1;
}

::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 6px;
}

::-webkit-scrollbar-thumb:hover {
    background: #555;
}

:global(html.dark-theme .attributes-page .filters-block h5) {
    color: var(--dark-text) !important;
}

:global(html.dark-theme .attributes-page .filters-block .filters a) {
    color: var(--dark-text-muted) !important;
}

:global(html.dark-theme .attributes-page .filters-block .filters a i) {
    color: var(--dark-primary) !important;
}

:global(html.dark-theme .attributes-page .filters-block .filters a:hover) {
    background: rgba(148, 163, 184, 0.08) !important;
    color: var(--dark-text) !important;
}

:global(html.dark-theme .attributes-page .filters-block .filters a.active) {
    background: var(--dark-primary-soft) !important;
    color: var(--dark-text) !important;
}

:global(html.dark-theme .attributes-tab) {
    background: var(--dark-surface) !important;
    border-color: rgba(148, 163, 184, 0.16) !important;
}

:global(html.dark-theme .attributes-tab:hover) {
    border-color: rgba(94, 234, 212, 0.24) !important;
}

:global(html.dark-theme .attributes-tab.background-active-header) {
    background: var(--dark-primary-soft) !important;
    border-color: rgba(94, 234, 212, 0.4) !important;
    box-shadow: 0 6px 16px rgba(2, 6, 23, 0.3) !important;
}

:global(html.dark-theme .attributes-tab__link) {
    color: var(--dark-text-muted) !important;
}

:global(html.dark-theme .attributes-tab__link.active) {
    color: var(--dark-primary) !important;
}

:global(html.dark-theme .attribute-card) {
    background: rgba(148, 163, 184, 0.08) !important;
    border-color: rgba(148, 163, 184, 0.16) !important;
}

:global(html.dark-theme .attribute-card:hover) {
    border-color: rgba(94, 234, 212, 0.24) !important;
    box-shadow: 0 6px 16px rgba(2, 6, 23, 0.3) !important;
}

:global(html.dark-theme .attribute-card__name) {
    color: var(--dark-text) !important;
}

:global(html.dark-theme .attribute-card__switch) {
    border-top-color: rgba(148, 163, 184, 0.12) !important;
}

:global(html.dark-theme .task-section) {
    background: rgba(15, 23, 42, 0.4) !important;
    box-shadow: 0 0 15px rgba(2, 6, 23, 0.4) !important;
    border-bottom-color: rgba(148, 163, 184, 0.12) !important;
}
</style>